import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { timeOffService } from '../api/time-off.service';
import { TIME_OFF_KEYS } from './queryKeys';
import type { CreateTimeOffRequestPayload } from '../types';

/** Returns the full `TimeOffRequestDto` — including the resolved `steps[]` chain — immediately. */
export function useCreateTimeOffRequest() {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useMutation({
    mutationFn: (payload: CreateTimeOffRequestPayload) => timeOffService.createRequest(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['time-off', 'me', 'requests', orgId] });
      queryClient.invalidateQueries({ queryKey: TIME_OFF_KEYS.myBalance(orgId) });
      queryClient.invalidateQueries({ queryKey: TIME_OFF_KEYS.mySummary(orgId) });
      queryClient.invalidateQueries({ queryKey: TIME_OFF_KEYS.approvals(orgId) });
    },
  });
}
